export default import.meta.ROLLDOWN_FILE_URL_aqL0Wyucvq3zDdADMWusEg